
import '../App.css';
import {
    BrowserRouter,
    Routes, //replaces "Switch" used till v5
    Route,
    HashRouter
} from "react-router-dom";
import React, { useState, useEffect } from 'react';
//import Home from './Home';

import ReactModal from 'react-modal';
import { auth } from '../config';
//import { ToastContainer, toast } from 'react-toastify';
import { toast } from 'wc-toast'

import Home from './Home';
import Membership from './Membership';
//import 'react-toastify/dist/ReactToastify.css';

export default function App() {

    const [pass, setPass] = useState('');
    const [touched1, setTouched1] = useState(false);
    const [password_pop_up, setPasswordPopUp] = useState(true);

    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        // Handle smooth animation when clicking without holding
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const __doSingIn = async () => {
        try {
            let response = await auth.signInWithEmailAndPassword("n.joy@boomsoftware.co.uk", "2103199j");
        } catch (e) {
            console.error(e.message);
        }
    };

    function checking() {
        if (pass == "123") { __doSingIn() }
        else { toast("Wrong password !") }
    }

    useEffect(() => {
        __doSingIn()
    }, [])

    return (
        <div className="App">
            <HashRouter>
                <Routes>


                    <Route path="/" element={<Home />} />
                    
                    <Route path="/Membership" element={<Membership />} />


                   


                </Routes>
            </HashRouter>
            <wc-toast></wc-toast>
        </div>
    );
}